import { Stack, usePathname } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";

export default function AssessmentsLayout() {
  const pathname = usePathname();

  return (
    <PageLayout
      className="py-dashboard"
      currentPath={pathname}
      screenName="Assessments"
      headerClassName="mx-dashboard"
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
